import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/base/sheet";

import { DeviceCard } from "./DeviceCard";

/** What the merchant's phone last told us about itself. */
export function MobilePlatformSheet({
  open,
  onOpenChange,
  businessId,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  businessId: string;
}) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-full gap-0 p-0 sm:max-w-[563px]">
        <SheetHeader className="border-border border-b px-6 py-4">
          <SheetTitle className="text-foreground text-lg font-semibold">
            Mobile app
          </SheetTitle>
        </SheetHeader>

        <div className="overflow-y-auto">
          {open && <DeviceCard businessId={businessId} />}
        </div>
      </SheetContent>
    </Sheet>
  );
}
